// #3586 -- the "Related reports" quick pick on Class Placings. Each entry is a
// class-scoped report that opens from the class on screen with no class to
// pick again: the link deep-links ReportsPage (?report&showId&classId), which
// preselects the class and auto-runs it through its normal run path.
//
// `key` tells two entries apart when they open the same def. #3587 (report
// 296): the Mid-Class Report is NOT a separate def. score.final-class prints as
// the Mid-Class Report while any placing group has no current placings, so the
// "Mid-Class Report" link opens that same def and the report decides its title.
export const RELATED_CLASS_REPORTS = [
  // #3588: `lockable` = locked (with the server's reason) while the class has
  // placing groups that lack current placings. The Mid-Class Report below never
  // locks: it is the in-progress print.
  { key: "score.final-class", reportId: "score.final-class", labelKey: "placings.finalClassReport", lockable: true },
  { key: "mid-class", reportId: "score.final-class", labelKey: "placings.midClassReport" },
  // #3599 -- the panel's per-judge score review for the class.
  { key: "score.judges-score-review", reportId: "score.judges-score-review", labelKey: "placings.judgesScoreReviewReport" },
];

export function relatedReportPath(reportId, showId, classId) {
  const qs = new URLSearchParams({ report: reportId, showId, classId });
  return `/reports?${qs.toString()}`;
}
